<script>
import Home from '@/views/Home'
import FakeStatusBar from '@/components/FakeStatusBar'
import MainMenu from '@/components/MainMenu'
import CircleSpinner from '@/components/CircleSpinner'
import LocalStorageUtils from '@/utils/localStorageUtils'
import EnvironmentUtils from '@/utils/environmentUtils'
import DOMUtils from '@/utils/DOMUtils'
import Theme from '@/theme'
const REF_APP = 'app'
const REF_ROUTER = 'router'

export default
{
    name: 'app',

    props:
    {
        fullscreenSpinner: { type: Boolean }
    },

    render () 
    {
        return (
            <div id='app' ref={REF_APP}>
                <div id='fullscreen-spinner' v-show={this.showFullscreenSpinner}>
                    <CircleSpinner circle-color='white' />
                </div>

                {/* This makes the app area start right from the top */}
                <div style={{ height: 0 }}>&nbsp;</div>

                {/* Provides the status bar background, real status bar background is set to transparent
                cause cordova status bar plugin is fucked up so things work better this way */}
                <FakeStatusBar ref='statusBar' />

                <router-view ref={REF_ROUTER} />
                
                <main-menu ref='mainMenu' orientation={DOMUtils.reactives.currentMediaName == 'desktop' ? 'vertical' : 'horizontal'} />
            </div>
        );
    },

    created ()
    {
    },

    mounted ()
    {
        document.addEventListener('deviceready', this.onDeviceReady, false);

        if (cordova.platformId == 'ios')
        {
            window.addEventListener('keyboardWillShow', this.onScreenKeyboardShown);
            window.addEventListener('keyboardWillHide', this.onScreenKeyboardHidden);
        }
        else
        {
            window.addEventListener('focus', event =>
            {
                const isElemInput = elem => ((elem || {}).tagName || '').toLowerCase() == 'input' || (elem.className || '').includes('ql-editor')
                if (isElemInput(event.target)) this.onScreenKeyboardShown(event)
            }, true);
            window.addEventListener('blur', this.onScreenKeyboardHidden, true);
        }

        window.addEventListener('online', this.onOnline, false)
        window.addEventListener('offline', this.onOffline, false)

        this.$router.afterEach((to, from, next) =>
        {
            document.dispatchEvent(new CustomEvent('router-after-each', {detail: {to, from, next}}))

            window.scrollTo(0, 0)
        });

        this.$nextTick(() =>
        {
            console.log('⚡ App mounted')
            document.dispatchEvent(new CustomEvent('appmounted'))
        })
    },

    data ()
    {
        return {
            isKeyboardVisible: false,
            isOnline: navigator.onLine,
            showFullscreenSpinner: false
        }
    },

    computed:
    {
        app ()
        {
            return this.$refs[REF_APP]
        },

        router ()
        {
            return this.$refs[REF_ROUTER]
        },
    },

    watch:
    {
        fullscreenSpinner ()
        {
            this.showFullscreenSpinner = this.fullscreenSpinner
        }
    },

    methods:
    {
        onDeviceReady (event)
        {
            this.onWindowResized(event)
            window.addEventListener('resize', this.onWindowResized);
            window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', this.onSystemThemeChanged)
        },

        onWindowResized (event)
        {
            Theme.applyTheme()
        },

        onSystemThemeChanged (event)
        {
            Theme.current = Theme.themes[LocalStorageUtils.activeTheme] || Theme.themes.auto
            Theme.applyTheme()
        },

        onScreenKeyboardShown ()
        {
            if (cordova.platformId == 'ios')
            {
                this.$refs.statusBar.isVisible = false
                this.$refs.mainMenu.isVisible = false
                window.document.body.style.paddingBottom = '5vh'
            }
            else if (cordova.platformId == 'android')
            {
                window.document.body.style.paddingBottom = Theme.properties.keyboardHeight
            }

            this.isKeyboardVisible = true
        },

        onScreenKeyboardHidden ()
        {
            // ensure that keyboard has been hidden for longer than 100ms:
            // especially useful when switching from one input to another.
            setTimeout(() =>
            {
                if (this.isKeyboardVisible) return

                if (cordova.platformId == 'ios')
                {
                    this.$refs.statusBar.isVisible = true
                    
                    const routeHideMainMenu = this.$route.meta.hideMainMenu
                    this.$refs.mainMenu.isVisible = routeHideMainMenu != undefined ? !routeHideMainMenu : true
                }

                window.document.body.style.paddingBottom = 0
            }, 100)

            this.isKeyboardVisible = false
        },

        onOnline ()
        {
            if (LocalStorageUtils.token != null)
            {
                window.app.$store.dispatch('user/fetchUserInformationFromToken', {token: LocalStorageUtils.token, cityId: EnvironmentUtils.cityId})
            }

            if (this.$route.path == '/offline')
            {
                this.showFullscreenSpinner = true
                this.$router.replace('/home')
                setTimeout(() => this.showFullscreenSpinner = false, 3000)
            }

            this.isOnline = true
        },

        onOffline ()
        {
            if (!navigator.splashscreen.visible && this.$route.path != '/offline')
            {
                this.$toast.warning('Vous êtes hors-ligne, cette application a besoin d\'une connexion internet pour fonctionner',
                    { duration: 10e6 })
            }

            this.isOnline = false
        }
    },
    
    components:
    {
        Home,
        FakeStatusBar,
        MainMenu,
        CircleSpinner
    }
}
</script>

<style lang='less'>
@import '~@/styles/app.less';

#app
{
    #fullscreen-spinner
    {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        background-color: var(--theme-background-color);
        width: 100vw;
        height: 100vh;
        z-index: 4;

        .circle-spinner
        {
            fill: var(--theme-border-color-extra-strong);
            width: 20vw;

            .OnDesktop({ width: 5vw; });
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue